import userAccount from '../../views/user-manage/user-account.vue';
import userAuth from '../../views/user-manage/user-auth.vue';
import addRole from '../../components/auth-manage/role-manage/add-role.vue';
import addAccount from '../../components/auth-manage/role-manage/add-account.vue';
var userManage = [
    {
        name: 'userAccount',
        path: 'user-account',
        component: userAccount,
    },
    {
        name: 'userAuth',
        path: 'user-auth',
        component: userAuth,
    },
    {
        name: 'addRole',
        path: 'user-auth/add-role',
        component: addRole,
    },
    {
        name: 'addAccount',
        path: 'user-auth/add-account',
        component: addAccount,
    },
];
export default userManage;
